import { Container, Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";
import colorSharp from "../assets/img/color-sharp.png";
import { ScrollingIcons } from "./ScrollingIcons";

const skillCategories = [
    {
        label: "Frontend Development",
        skills: ["HTML5", "CSS3", "Sass", "JavaScript", "TypeScript", "React", "Next.js", "Bootstrap", "Tailwind CSS"],
    },
    {
        label: "Backend & Database",
        skills: ["Node.js", "Firebase", "Supabase", "MongoDB", "REST APIs"],
    },
    {
        label: "Tools & Workflow",
        skills: ["Git", "GitHub", "Figma", "Framer Motion", "Vite", "VS Code"],
    },
    {
        label: "SEO & Marketing",
        skills: ["SEO Optimization", "Google Analytics", "Social Media Mgmt", "Content Strategy", "WordPress"],
    },
];

const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    visible: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.55, delay: i * 0.1, ease: [0.4, 0, 0.2, 1] },
    }),
};

export const Skills = () => {
    return (
        <section className="skill" id="skills">
            <Container>
                <Row>
                    <Col>
                        <div className="skill-bx">
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, margin: "-80px" }}
                            >
                                <motion.span className="section-tag" variants={fadeUp} custom={0}>
                                    What I Do
                                </motion.span>
                                <motion.h2 variants={fadeUp} custom={1}>
                                    Skills &amp; Expertise
                                </motion.h2>
                                <motion.p className="section-subtitle" variants={fadeUp} custom={2}>
                                    I blend technical precision with creative thinking — from building
                                    high-performance web applications to driving organic growth through
                                    data-driven SEO and digital marketing.
                                </motion.p>
                            </motion.div>

                            <motion.div
                                className="skill-categories"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, margin: "-60px" }}
                            >
                                {skillCategories.map((cat, i) => (
                                    <motion.div
                                        className="skill-category-card"
                                        key={i}
                                        variants={fadeUp}
                                        custom={i}
                                    >
                                        <h4>{cat.label}</h4>
                                        <div className="skill-tags">
                                            {cat.skills.map((skill, j) => (
                                                <span className="skill-tag" key={j}>{skill}</span>
                                            ))}
                                        </div>
                                    </motion.div>
                                ))}
                            </motion.div>

                            <ScrollingIcons />
                        </div>
                    </Col>
                </Row>
            </Container>
            <img className="background-image-left" src={colorSharp} alt="" aria-hidden="true" />
        </section>
    );
};
